import { createSelector } from '@ngrx/store';

import { createEntityCollectionStore, ID, memoizeSelector } from '@recruitee/ngrx';

import { AssignedJobEntity } from './assigned-jobs.types';

const { actions, namespace, selectors, reducer } = createEntityCollectionStore<AssignedJobEntity>()(
  'RequisitionsAssignedJobs',
);

const AssignedJobsActions = {
  fetchOne: actions.fetchOne,
  fetchOneSuccess: actions.fetchOneSuccess,
  fetchOneFailed: actions.fetchOneFailed,
};

const AssignedJobsSelectors = {
  ...selectors,
  byId: memoizeSelector((id: ID) => createSelector(selectors.byId(id), entity => entity?.jobs)),
};

export {
  AssignedJobsActions,
  AssignedJobsSelectors,
  namespace as AssignedJobsNamespace,
  reducer as AssignedJobsReducer,
};
